"use client"

import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import axios from "axios"
import { baseUrl } from "../../config/baseUrl"
import empty from "../../assets/images/empty-box.png"
import Swal from "sweetalert2"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faClipboardList,
  faPlus,
  faEye,
  faEdit,
  faTrash,
  faCheck,
  faTimes,
  faSearch,
  faClock,
  faQuestionCircle,
  faUsers,
  faRupeeSign,
  faList12,
} from "@fortawesome/free-solid-svg-icons"
import moment from "moment/moment"
import { toast } from "react-toastify"
import Pagination from "../Pagination/Pagination"
import useHorizontalDragScroll from "../../hooks/useHorizontalDragScroll"

export default function TestSeriesList() {
  const [testSeries, setTestSeries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState(""); // "active" / "inactive"
  const [categoryFilter, setCategoryFilter] = useState(""); // optional if needed
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalTests, setTotalTests] = useState(0);
  const [pageInfo, setPageInfo] = useState({
    page: 1,
    limit: 25,
    totalPages: 1,
    totalCount: 0,
  });
  const dragScrollProps = useHorizontalDragScroll();

  useEffect(() => {
    fetchTestSeries();
  }, [currentPage, searchTerm, statusFilter, categoryFilter]);

  // const fetchTestSeries = async () => {
  //   try {
  //     setLoading(true);

  //     const params = {
  //       page: currentPage,
  //     };

  //     if (searchTerm) params.search = searchTerm;
  //     if (statusFilter) params.status = statusFilter;
  //     if (categoryFilter) params.category = categoryFilter;

  //     const response = await axios.get(`${baseUrl}/test`, {
  //       headers: {
  //         Authorization: localStorage.getItem("token"),
  //       },
  //       params,
  //     });

  //     if (response.data?.status) {
  //       setTestSeries(response.data.data);
  //       setTotalPages(response.data.totalPages || 1);
  //     } else {
  //       setTestSeries([]);
  //       setTotalPages(1);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching test series:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Example: change page


  const fetchTestSeries = async () => {
    try {
      setLoading(true);

      const params = { page: currentPage };
      if (searchTerm) params.search = searchTerm;
      if (statusFilter) params.status = statusFilter;
      if (categoryFilter) params.category = categoryFilter;

      const response = await axios.get(`${baseUrl}/test`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
        params,
      });

      if (response.data?.status) {
        setTestSeries(response.data.data || []);
        setPageInfo({
          page: response.data.pagination?.currentPage || 1,
          limit: response.data.pagination?.limit || 25,
          totalPages: response.data.pagination?.totalPages || 1,
          totalCount: response.data.pagination?.totalCount || 0,
        });
      } else {
        setTestSeries([]);
        setPageInfo({
          page: 1,
          limit: 25,
          totalPages: 1,
          totalCount: 0,
        });
      }
    } catch (error) {
      console.error("Error fetching test series:", error);
    } finally {
      setLoading(false);
    }
  };




  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Example: search input
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // reset page to 1 on new search
  };

  // Example: status filter
  const handleStatusFilter = (status) => {
    setStatusFilter(status);
    setCurrentPage(1);
  };


  const handleStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active"
    try {
      await axios(`${baseUrl}/test/${id}`, {
        method: "PATCH",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
        data: { status: newStatus }
      })
      fetchTestSeries()
      toast.success("Status Updated Successfully")
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Failed to update status",
        icon: "error",
      })
    }
  }

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`${baseUrl}/test/${id}`, {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        });

        // Update local state by filtering out the deleted item
        setTestSeries(prev => prev.filter(item => item._id !== id));

        toast.success("Test Series Deleted Successfully");
      } catch (error) {
        Swal.fire("Error!", "Failed to delete test series.", "error");
      }
    }
  };




  const truncateText = (text, maxLength = 50) => {
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text
  }

  const getDifficultyBadge = (difficulty) => {
    const badges = {
      easy: "bg-success",
      medium: "bg-warning",
      hard: "bg-danger",
    }
    return badges[difficulty] || "bg-secondary"
  }
  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value)
    setCurrentPage(1) // reset to first page
  }

  // Handle status filter change
  const handleStatusChange = (e) => {
    setStatusFilter(e.target.value)
    setCurrentPage(1)
  }
  return (
    <>


      <section className="main-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="dashboard-title">
                <h4 className="dash-head">
                  <FontAwesomeIcon icon={faClipboardList} className="me-2" />
                  Test Series
                </h4>
              </div>
              <div className="custom-bredcump">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Test Series List
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <div className="col-lg-6 d-flex justify-content-end align-items-start">
              <Link to="create" className="btn-add-test">
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                Add Test Series
              </Link>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="cards bus-list">
                <div className="bus-filter">
                  <div className="row align-items-center">
                    <div className="col-lg-6">
                      <h5 className="card-title">Tst Series List ({pageInfo.totalCount || testSeries.length})</h5>
                    </div>
                  </div>
                </div>

                <div className="search-filter-container">
                  <div className="search-container">
                    <FontAwesomeIcon icon={faSearch} className="search-icon" />
                    <input
                      type="text"
                      className="search-input"
                      placeholder="Search test series..."
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                  </div>
                  <select
                    className="filter-select"
                    value={statusFilter}
                    onChange={handleStatusChange}
                  >
                    <option value="">All Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                  {/*  */}
                </div>

                <div className="table-responsive custom-table" {...dragScrollProps}>
                  <table className="table table-borderless">
                    <thead>
                      <tr>
                        <th>SN</th>
                        <th>Test Series</th>
                        <th>Details</th>
                        <th>Marks</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Assign Question</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="8" className="loading-spinner">
                            <div className="spinner"></div>
                          </td>
                        </tr>
                      ) : testSeries.length === 0 ? (
                        <tr>
                          <td colSpan="8" className="empty-state">
                            <img src={empty || "/placeholder.svg"} alt="No test series" width="200px" />
                            <h4>No Test Series found!</h4>
                            <p className="text-muted">
                              {searchTerm || statusFilter || categoryFilter
                                ? "Try adjusting your search or filter criteria"
                                : "Start by creating your first test series"}
                            </p>
                          </td>
                        </tr>
                      ) : (
                        testSeries.map((test, i) => (
                          <tr key={test?._id}>
                            <td>{(pageInfo.page - 1) * pageInfo.limit + (i + 1)}</td>

                            <td>
                              <h6>{truncateText(test?.title, 40)}</h6>
                              <p className="text-muted">{test?.packageId?.title}</p>
                            </td>
                            <td>
                              <div className="stats-container">
                                <div className="stat-item">
                                  <FontAwesomeIcon icon={faClock} className="stat-icon" />
                                  <span>{test?.duration} minutes</span>
                                </div>
                                <div className="stat-item">
                                  <FontAwesomeIcon icon={faQuestionCircle} className="stat-icon" />
                                  <span>{test?.questionCount || 0} questions</span>
                                </div>
                                {/* <div className="stat-item">
                                  <FontAwesomeIcon icon={faUsers} className="stat-icon" />
                                  <span>{test?.enrolledCount || 0} enrolled</span>
                                </div> */}
                              </div>
                            </td>
                            <td>
                              <div className="stats-container">
                                <div className="stat-item">
                                  <FontAwesomeIcon icon={faClock} className="stat-icon" />
                                  <span>Total Marks {test?.marks}</span>
                                </div>
                                <div className="stat-item">
                                  <FontAwesomeIcon icon={faQuestionCircle} className="stat-icon" />
                                  <span>Positive Marks {test?.positiveMark || 0}</span>
                                </div>
                                <div className="stat-item">
                                  <FontAwesomeIcon icon={faUsers} className="stat-icon" />
                                  <span>Negative Marks {test?.negativeMark || 0} </span>
                                </div>
                              </div>
                            </td>
                            <td>
                              {moment(test?.createdAt).format("lll")}
                            </td>
                            <td>
                              <button
                                onClick={() => handleStatus(test?._id, test?.status)}
                                className={`status-badge ${test.status === "active"
                                  ? "status-active"
                                  : test.status === "inactive"
                                    ? "status-inactive"
                                    : "status-draft"
                                  }`}
                              >
                                {test?.status === "active" ? (
                                  <>
                                    <FontAwesomeIcon icon={faCheck} className="me-1" />
                                    Active
                                  </>
                                ) : test?.status === "inactive" ? (
                                  <>
                                    <FontAwesomeIcon icon={faTimes} className="me-1" />
                                    Inactive
                                  </>
                                ) : (
                                  <>
                                    <FontAwesomeIcon icon={faEdit} className="me-1" />
                                    Draft
                                  </>
                                )}
                              </button>
                            </td>
                            <td>
                              <div className="action-buttons">
                                <Link to={`questions/${test?._id}`} className="action-btn view-btn">
                                  {test?.questionCount || 0}
                                  <span className="tooltip-text">Question List</span>
                                </Link>
                                <Link to={`questions/assign/${test?._id}`} className="action-btn edit-btn">
                                  <FontAwesomeIcon icon={faQuestionCircle} />
                                  <span className="tooltip-text">Assign</span>
                                </Link>
                              </div>
                            </td>
                            <td>
                              <div className="action-buttons">
                                <Link to={`/test-series/edit/${test?._id}`} className="action-btn edit-btn">
                                  <FontAwesomeIcon icon={faEdit} />
                                  <span className="tooltip-text">Edit</span>
                                </Link>
                                <button className="action-btn delete-btn" onClick={() => handleDelete(test?._id)}>
                                  <FontAwesomeIcon icon={faTrash} />
                                  <span className="tooltip-text">Delete</span>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                  {pageInfo.totalPages > 1 && (
                    <Pagination
                      pageNumber={pageInfo.page}
                      totalPages={pageInfo.totalPages}
                      setPageNumber={(newPage) => {
                        setCurrentPage(newPage);
                      }}
                      totalCount={pageInfo.totalCount}
                      limit={pageInfo.limit}
                    />
                  )}


                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
